import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, InputModule, RadioCheckboxModule, FormFieldsModule, RadioCheckboxListModule, ProgressModule, LibPopoverModule, SelectModule, NgxSmartModalModule } from '@bssh/comp-lib';
import { ReactiveFormsModule } from '@angular/forms';
import { ComboBoxModule } from '@app/cloud-run-prep/directives/combobox/combobox.module';
import { LibraryPrepKitModalComponent } from './library-prep-kit-modal.component';

@NgModule({
  declarations: [LibraryPrepKitModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    InputModule,
    RadioCheckboxModule, 
    ButtonModule,
    FormFieldsModule, 
    RadioCheckboxListModule, 
    ProgressModule, 
    LibPopoverModule,
    ReactiveFormsModule,
    ComboBoxModule,
    SelectModule,
    NgxSmartModalModule
  ],
  exports: [LibraryPrepKitModalComponent]
})
export class LibraryPrepKitModalModule { }
